const STYLES = {
  ready: ["Ready to drink", "bg-[#2E5D4B]/30 text-emerald-300 border-[#2E5D4B]"],
  soon: ["Drink soon", "bg-[#E5A93C]/15 text-[#E5A93C] border-[#E5A93C]/40"],
  past: ["Past peak", "bg-[#5C1D24]/40 text-[#F5A3A3] border-[#8C2B36]"],
  not_ready: ["Not ready", "bg-[#1E181B] text-[#A89F91] border-[#2E252A]"],
};

export const DRINK_LABELS = Object.fromEntries(Object.entries(STYLES).map(([k, v]) => [k, v[0]]));

export const DrinkBadge = ({ status, testId }) => {
  if (!STYLES[status]) return null;
  const [label, cls] = STYLES[status];
  return <span className={`inline-block px-2 py-0.5 rounded border font-mono text-[10px] uppercase tracking-widest whitespace-nowrap ${cls}`} data-testid={testId}>{label}</span>;
};
